// eslint-disable-next-line import/prefer-default-export
export const REQUEST_SEARCH_PERSON =
  'person/validatesearchperson/REQUEST_SEARCH_PERSON';

export const REQUEST_SEARCH_VALIDATE_PERSON =
  'person/validatesearchperson/REQUEST_SEARCH_VALIDATE_PERSON';

export const REQUEST_SEARCH_VALIDATE_BENEFICIARY_PERSON =
  'person/validatesearchperson/REQUEST_SEARCH_VALIDATE_PERSON_TWO';

export const REQUEST_SEARCH_VALIDATE_SHAREHOLDER =
  'person/validatesearchperson/REQUEST_SEARCH_VALIDATE_SHAREHOLDER';
